import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject } from 'rxjs';
import { AppConstant } from 'src/app/app.constant';
import { IdNameModel } from '../../attendance/attendance.classes';
import { DataToDelete } from 'src/app/_metronic/core/classes/core.class';
@Injectable()
export class SubjectService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
        this.kendoDataUrl = this.apiUrl + 'GetAll';
    }
    manageSubject(subject) {
        return this.httpClient.post(`${this.apiUrl}/manageSubject`, subject).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    bulkInsert(SubjectData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportSubject`, SubjectData).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getSubjectById(Id) {
        return this.httpClient.get(`${this.apiUrl}/getSubjectById/`+ Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllSubjectKendo(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllSubject`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    async getAllSubjectName() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllSubject/`).toPromise()).data;
    }

    getAllSubjectNames(SubjectData) {
        return this.httpClient.post(`${this.apiUrl}/getAllSubjectName`, SubjectData).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getAllSubjectExcel() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllSubject`).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    deleteMultipleSubject(subjectIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteSubject/`, {
            DataToDelete: subjectIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }

    // specific Subject
    manageSpecificSubject(subject) {
        return this.httpClient.post(`${this.apiUrl}/manageSpecificSubject`, subject).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    bulkInsertSpecificSubject(SpecificSubjectData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportSpecificSubject`, SpecificSubjectData).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getSpecificSubjectById(Id) {
        return this.httpClient.get(`${this.apiUrl}/getSpecificSubjectById/`+ Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllSpecificSubjectKendo(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllSpecificSubject`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    async getAllSpecificSubjectName() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getSpecificSubjectName/`).toPromise()).data;
    }

    getAllSpecificSubjectExcel() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllSpecificSubject`).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    deleteMultipleSpecificSubject(subjectIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteSpecificSubject/`, {
            DataToDelete: subjectIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }
}
